import React from 'react';

interface StatusBadgeProps {
  status: 'active' | 'inactive' | 'pending';
  size?: 'sm' | 'md' | 'lg';
}

export default function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const statusConfig = {
    active: {
      bgColor: 'bg-green-100',
      textColor: 'text-green-800',
      borderColor: 'border-green-200',
      icon: '🟢'
    },
    inactive: {
      bgColor: 'bg-red-100',
      textColor: 'text-red-800',
      borderColor: 'border-red-200',
      icon: '🔴'
    },
    pending: {
      bgColor: 'bg-yellow-100',
      textColor: 'text-yellow-800',
      borderColor: 'border-yellow-200',
      icon: '🟡'
    }
  };

  const config = statusConfig[status];

  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1.5 text-sm',
    lg: 'px-4 py-2 text-base'
  };

  const label = status?.charAt(0).toUpperCase() + status?.slice(1);

  return (
    <span 
      className={`
        ${config?.bgColor} 
        ${config?.textColor} 
        ${config?.borderColor}
        ${sizeClasses[size]}
        font-medium 
        rounded-full 
        border 
        inline-flex 
        items-center 
        gap-1
      `}
    >
      <span className="text-xs">{config?.icon}</span>
      {label}
    </span>
  );
} 